import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { ActionPlansListFiltersStore } from '@/contexts/action-plans/ActionPlans.interfaces'

export const useActionPlansListFiltersStore = defineStore(
  'action-plans-list-filters',
  () => {
    const actionPlansListFilters = ref<ActionPlansListFiltersStore[]>([])

    const updateActionPlansListFilters = (filters: ActionPlansListFiltersStore) => {
      const filterIndex = actionPlansListFilters.value.findIndex(
        (storeFilter) => storeFilter.customerId === filters.customerId
      )

      if (filterIndex >= 0) {
        actionPlansListFilters.value.splice(filterIndex, 1, filters)
      } else {
        actionPlansListFilters.value.push(filters)
      }
    }

    const getActionPlansListFilter = (customerId: number): ActionPlansListFiltersStore | undefined => {
      return actionPlansListFilters.value.find((storedFilter) => storedFilter.customerId === customerId)
    }

    function $reset() {
      actionPlansListFilters.value = []
    }

    return { actionPlansListFilters, updateActionPlansListFilters, getActionPlansListFilter, $reset }
  },
  { persist: true }
)
